export default function (value: string | undefined) {
  return value?.toLowerCase();
}
